import React, { ReactNode, useState } from 'react'
import { useTranslation } from 'language/translator'

import SettingsEditDialog from 'components_new/molecules/SettingsEditDialog'
import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'

interface DecimalsSectionProps {
  numberOfDecimals: number
  onChange: (numberOfDecimals: number) => void

  // the setting is decided elsewhere, and the text says where
  disabled?: boolean
  disabledText?: ReactNode
}

const DecimalsSection = (props: DecimalsSectionProps) => {
  const {
    disabled, disabledText, numberOfDecimals, onChange
  } = props
  const { t } = useTranslation()

  /*-- dialog --*/
  const [dialog, setDialog] = useState<{ open: boolean; value: string }>({
    open: false,
    value: ''
  })

  const handleOpenDialog = () => {
    setDialog({ open: true, value: numberOfDecimals.toString() })
  }

  const handleEditDialogValue = (value: string) => {
    setDialog((prevState) => ({ ...prevState, value }))
  }

  const handleCloseDialog = () => {
    setDialog((prevState) => ({ ...prevState, open: false }))
  }

  const handleSubmitDialog = () => {
    onChange(parseInt(dialog.value))
  }

  return (
    <>
      <SettingsGroup title={t('widgets', 'decimals_title')}>
        <SettingsItem
          disabled={disabled}
          disabledText={disabledText}
          onClick={handleOpenDialog}
          title={t('widgets', 'number_of_decimals')}
          value={numberOfDecimals}
          variant="edit"
        />
      </SettingsGroup>

      <SettingsEditDialog
        clearValue="0"
        maxNumber={20}
        onChange={handleEditDialogValue}
        onClose={handleCloseDialog}
        onSubmit={handleSubmitDialog}
        open={dialog.open}
        options={[]}
        title={t('widgets', 'number_of_decimals')}
        type="number"
        value={dialog.value}
      />
    </>
  )
}

export default DecimalsSection
